import React, { useState } from "react";
import SingleSelectDropDownComponent from "../../../../_utils/CommonDropdown/SingleSelectDropdown";

const UserGrade = ({ userPayload, setUserPayload, gradeOption }) => {
  return (
    <div className="flex flex-col relative w-width-full mt-margin-md">
      <div className="py-padding-md bg-primary-card flex flex-col rounded-border-radius-md">
        <div className="w-width-full flex flex-col gap-gap-md">
          <div className="text-text-primary font-semibold text-base px-padding-md">
            User Grade
          </div>
        </div>
        <div className="px-padding-md pt-padding-md">
          <SingleSelectDropDownComponent
            type="big"
            options={gradeOption}
            selected={userPayload?.grade}
            setSelected={(val) => {
              setUserPayload({ ...userPayload, grade: val });
            }}
            showSearch={false}
            placeholder={"Select"}
          />
        </div>
      </div>
    </div>
  );
};

export default UserGrade;
